import { axiosPrivate } from '../../api/axios';

export const fetchCourseResources = (courseId) => async () => {
    const response = await axiosPrivate.get(`/api/resources/courses/${courseId}`);
    return response.data;
};

export const createCourseResources = (courseId, payload) => async () => {
    const response = await axiosPrivate.post(`/api/resources/courses/${courseId}`, payload);
    return response.data;
};

export const deleteCourseResource = (resourceId) => async () => {
    const response = await axiosPrivate.delete(`/api/resources/${resourceId}`);
    return response.data;
};

export const getResourcePresignedUploadUrl = (courseId, { fileName, mimeType, size }) => async () => {
    const response = await axiosPrivate.post('/api/resources/uploads/presign', {
        courseId,
        fileName,
        mimeType,
        size,
    });
    return response.data;
};
